import { Link } from "@tanstack/react-router";
import clsx from "clsx";

import { useUIStateStore } from "@/store/uiStateStore";

function NavItem(props) {
  const {
    highlightColour,
    icon,
    to,
    title,
    exact,
    iconIsFA,
    disabled,
    notification,
    externalLink,
    linkAddress,
    onClick,
  } = props;

  const isTunecore = useUIStateStore(state => state.isTunecore);

  // CONDITIONAL CLASSES FOR REBRAND
  const navItemClasses = clsx(
    "nav-text text-nav-text-normal text-xs font-semibold",
    {
      "text-sm leading-normal capitalize": !isTunecore,
      "text-sm leading-normal uppercase": isTunecore,
    },
  );

  // awaiting introduction of API call from KYC check to determine if passed Security check
  // in navItems.jsx eg disabled={!securityPassed} - Matt I
  if (disabled) {
    return (
      <Link
        activeOptions={{ exact: Boolean(exact) }}
        className="flex items-center w-full mb-2 nav-link group h-14 disabled-navlink"
        to={to}
      >
        <div className="w-1 h-full mr-4 nav-link-active" />
        <div className="w-1 h-full mr-4 nav-link-hover" />
        <div className="w-1 h-full mr-4 nav-link-normal" />
        {iconIsFA && (
          <div
            style={{ color: "rgba(152, 152, 152, 0.47)" }}
            className="w-10 h-5 mr-0 text-xl nav-image"
          >
            {icon}
          </div>
        )}
        {!iconIsFA && (
          <img
            className="object-contain object-left w-10 h-5 mr-0 nav-image"
            src={icon}
            alt=""
          />
        )}
        <span
          style={{ color: "rgba(95, 95, 95, 1)" }}
          id={`${title.replace(/\s/g, "")}_nav`}
          className="text-xs font-semibold nav-text text-nav-text-normal"
        >
          {title}
        </span>
      </Link>
    );
  }

  if (externalLink) {
    const handleClick = onClick || (() => (window.location.href = linkAddress));
    return (
      <div>
        <button
          type="button"
          onClick={handleClick}
          className="flex items-center w-full mb-2 nav-link group h-14 hover:text-white"
        >
          <div
            style={{
              backgroundColor: isTunecore ? "#00ef86" : highlightColour,
            }}
            className="nav-link-active h-full w-1.5 mr-4"
          />
          <div
            style={{ backgroundColor: "#40424b" }}
            className="nav-link-hover h-full w-1.5 mr-4"
          />
          <div className="nav-link-normal h-full w-1.5 mr-4" />
          {iconIsFA && (
            <div
              style={{ color: "#898fa1" }}
              className="w-10 h-5 mr-0 text-xl nav-image"
            >
              {icon}
            </div>
          )}
          {!iconIsFA && (
            <img
              className="object-contain object-left w-10 h-5 mr-0 nav-image"
              src={icon}
              alt=""
            />
          )}
          <span id="link" className={navItemClasses}>
            {title}
          </span>
        </button>
      </div>
    );
  }

  return (
    <Link
      activeOptions={{ exact: Boolean(exact) }}
      className="flex items-center w-full mb-2 nav-link group h-14"
      to={to}
    >
      <div
        style={{ backgroundColor: isTunecore ? "#00ef86" : highlightColour }}
        className="nav-link-active h-full w-1.5 mr-4"
      />
      <div
        style={{ backgroundColor: "#40424b" }}
        className="nav-link-hover h-full w-1.5 mr-4"
      />
      <div className="nav-link-normal h-full w-1.5 mr-4" />
      {iconIsFA && (
        <div
          style={{ color: "#898fa1" }}
          className="w-10 h-5 mr-0 text-xl nav-image"
        >
          {icon}
        </div>
      )}
      {!iconIsFA && (
        <img
          className="object-contain object-left w-10 h-5 mr-0 nav-image"
          src={icon}
          alt=""
        />
      )}
      <span id={`${title.replace(/\s/g, "")}_nav`} className={navItemClasses}>
        {title}
      </span>
      {notification}
    </Link>
  );
}

export default NavItem;
